// Mirrors the API's CANCELLATION_REASONS (onicares-api appointments/dto/cancel-appointments.dto.ts) and the
// reasons ONI Assist offers. The API words the chosen reason into the patient's cancellation notification.
export const CANCELLATION_REASONS = [
  { id: 'DOCTOR_BUSY', label: 'Doctor is busy' },
  { id: 'DOCTOR_UNAVAILABLE', label: 'Doctor is unavailable' },
  { id: 'RESCHEDULE', label: 'Reschedule the appointment' },
];

export const cancellationReasonLabel = (id) => CANCELLATION_REASONS.find((r) => r.id === id)?.label;
